import React from 'react';
import BaseComponent from '../common/BaseComponent/BaseComponent';

const ContextServicesFeaturesTable = React.createContext({});


class ContextServicesFeaturesTableProvider extends BaseComponent {

	constructor(props) {

		super(props);
		const contextName = typeof this.props.contextName === 'string' ? this.props.contextName : 'contextServicesFeaturesTable';
		this.componentName = SHVO.pageState.componentData[contextName].componentName;
		this.componentToken = SHVO.pageState.componentData[contextName].componentToken;


		this.state = {
			contextData: SHVO.pageState.componentData[contextName].componentData,
		}
	}


	render() {
		return (
		  <ContextServicesFeaturesTable.Provider value={this.state}>
			  {this.props.children}
		  </ContextServicesFeaturesTable.Provider>
		)
	}
}

export {ContextServicesFeaturesTable, ContextServicesFeaturesTableProvider};

